<template>
    <div id="marquee"
         class='marquee'>
        <span v-if='language === "nl"'>{{quoteStringNL}}</span>
        <span v-if='language === "en"'>{{quoteStringEN}}</span>
    </div>
</template>

<script>
export default {
  name: 'dsMarquee',
  props: ['language', 'quotes'],
  computed: {
    quoteStringNL() {
      let str = ''
      for (let i = 0; i < this.quotes.acf.quotes.length; i++) {
        str += ' ' + this.quotes.acf.quotes[i].quote
      }
      // IE
      return (
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str
      )
    },
    quoteStringEN() {
      let str = ''
      for (let i = 0; i < this.quotes.acf.quotes_en.length; i++) {
        str += ' ' + this.quotes.acf.quotes_en[i].quote
      }
      // IE
      return (
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str +
        ' ' +
        str
      )
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
.marquee {
  position: relative;
  pointer-events: none;
  @include screen-size ('x-small') {
    position: absolute;
    top: 0;
    display: none;
  }
  height: 100%;
  width: 1012px - 1.5 * $margin;
  @include screen-size ('medium') {
    width: 670px - 1.5 * $margin;
  }
  @include screen-size ('x-small') {
    width: 100%;
  }
  margin-left: 1.5 * $margin;
  overflow: hidden;
  height: 5 * $baseline;
  line-height: 5 * $baseline;
  position: relative;
  white-space: nowrap;
  box-sizing: border-box;
  // top: 1px;
  span {
    display: inline-block;
    text-indent: 0;
    animation: marquee 400s linear infinite;
  }
}
@keyframes marquee {
  0% {
    transform: translate(00%, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}
</style>



// WEBPACK FOOTER //
// dsMarquee.vue?34872875